const { FormControlLabel, Checkbox } = window.Material;

interface CheckBoxProps {
  className?: string;
  color?: 'primary' | 'secondary' | 'default';
  label: string;
  onChange?: (event: object) => void;
  disabled?: boolean;
  mandatory?: boolean;
  checked?: boolean;
  position?: string;
  id: string;
}

export default class EdocatCheckBox extends window.React.PureComponent<CheckBoxProps, {}> {
  static defaultProps: CheckBoxProps = {
    color: 'primary',
    disabled: false,
    className: '',
    label: '',
  };

  render() {
    const { className, checked, color, label, position, onChange, disabled, id } = this.props;
    // @ts-ignore
    return (
      <FormControlLabel
        label={label}
        value={position}
        control={
          <Checkbox
            id={id}
            disabled={disabled}
            className={className}
            checked={checked}
            onChange={onChange}
            color={color}
          />
        }
      />
    );
  }
}
